import React, { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  useApisMembersEmployeeSurveySubmissionsShow,
  useEmployeeSurveysSlideNavigation,
  useBoolean,
  useApisMembersEmployeeSurveySubmissionsEmployeeSurveySubmissionRepliesIndex,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import {
  EmployeeSurveySubmissionDetail,
  EmployeeSurveySubmissionRepliesWithEmployeeSurveySubmission,
} from "~/components/organisms";

import { MyRoutes } from "~/config/Paths";

import { RightSidebarTitle } from "~/ui";

export const MembersEmployeeSurveySubmissionsShow: FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const { isChecked: replayOpen, toggle, setFalse: close } = useBoolean(true);
  const navigate = useNavigate();
  const breadCrumbItems = [
    {
      label: "チェックアウト",
      href: MyRoutes.Members.inputEmployeeSurveysIndex(),
    },
    {
      label: "一覧",
      href: MyRoutes.Members.employeeSurveySubmissionsIndex(),
    },
  ];

  const { navigations } = useEmployeeSurveysSlideNavigation({
    selectedArray: [false, true],
  });

  const { data } = useApisMembersEmployeeSurveySubmissionsShow({ id });
  const { data: repliesIndexData, refetch: repliesRefetch } =
    useApisMembersEmployeeSurveySubmissionsEmployeeSurveySubmissionRepliesIndex(
      {
        employeeSurveySubmissionId: id,
      },
    );

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent navigations={navigations} withRightSidebar>
        {data && (
          <EmployeeSurveySubmissionDetail
            employeeSurveySubmission={data.employeeSurveySubmission}
            openReply={toggle}
            className="mt-12"
            refetch={() => {
              close();
              navigate(MyRoutes.Members.employeeSurveySubmissionsIndex());
            }}
            canDelete
          />
        )}
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar>
        {replayOpen && repliesIndexData && (
          <>
            <RightSidebarTitle title="リプライ" />
            <EmployeeSurveySubmissionRepliesWithEmployeeSurveySubmission
              className="mt-6"
              employeeSurveySubmission={
                repliesIndexData.employeeSurveySubmission
              }
              mentions={[]}
              employeeSurveySubmissionReplies={
                repliesIndexData.employeeSurveySubmissionReplies || []
              }
              refetch={repliesRefetch}
            />
          </>
        )}
      </EmployeeLayoutRightSidebar>
    </EmployeeLayout>
  );
};
